// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/SortableItemList.css
// module id = 2066
// module chunks = 3